import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

import { RolesService } from "../../../services/roles.service";
import { ToastrService } from "../../../services/toastr.service";

import FormSection from "../../vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        FormSection
    },

    data() {
        return {
            dialogReference: this.dialogRef as any,
            _roleService: null as RolesService,
            _toastrService: null,
            options: null,
            signature: "",
            validSignature: false,
            isVerifying: false,
            isLoading: true,
            organizationName: "",
            v$: useVuelidate()
        };
    },
    created() {
        this._roleService = Container.instance.get(RolesService);
        this._toastrService = Container.instance.get(ToastrService);
    },
    validations() {
        return {
            signature: { required }
        };
    },
    mounted() {
        this.organizationName = this.dialogReference.data.organizationName;
        this.isLoading = false;
    },
    methods: {
        async verifySignature() {
            try {
                const result = await this._roleService.getUserSignatureVerification({
                    Signature: this.signature
                });
                if (result.IsValid) {
                    return this.dialogReference.close("success");
                } else {
                    this._toastrService.error({
                        title: `Signature Verification Failed`,
                        message: result?.Message || "Signature is not valid, Please enter correct Signture!"
                    });
                }
            } catch (err) {
                console.log(err);
                this._toastrService.error({
                    title: `Signature Verification Failed`,
                    message: `Verifying Signature Failed, Please Contact Axxess if issue persist.`
                });
            }
        },

        cancel() {
            return this.dialogReference.close("cancelled");
        }
    }
});
